export default "__VITE_ASSET__CGV0dCbF__"